export default __webpack_public_path__ + "static/media/Confirmed.1b77cb2b.svg";